import { render } from "./InputConsole.vue?vue&type=template&id=1f32bc1b&ts=true"
import script from "./InputConsole.vue?vue&type=script&lang=ts"
export * from "./InputConsole.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__